function isStringValue(value) {
  return typeof value === 'string' && value !== '';
}
function isArrayValue(value) {
  return Array.isArray(value) && value.every(_ => typeof _ === 'string' && _ !== '');
}
function isBooleanValue(value) {
  return typeof value === 'boolean';
}
/**
 * @deprecated Use the ConfigurationContext instead, to fetch the configuration values.
 */
class ConfigurationProvider {
  constructor() {
    this.values = {};
  }
  provideValues(values) {
    Object.assign(this.values, values);
  }
  getValue(key) {
    if (isStringValue(this.values[key])) {
      return this.values[key];
    }
    throw new Error("Missing configuration value or other type than 'string': ".concat(key));
  }
  getValueAsArray(key) {
    if (isArrayValue(this.values[key])) {
      return this.values[key];
    }
    throw new Error("Missing configuration value or other type than 'string[]': ".concat(key));
  }
  getValueAsBoolean(key) {
    if (isBooleanValue(this.values[key])) {
      return this.values[key];
    }
    throw new Error("Missing configuration value or other type than 'boolean': ".concat(key));
  }
}
/**
 * @deprecated Use the ConfigurationContext instead, to fetch the configuration values.
 */
const configurationProvider = new ConfigurationProvider();
export default configurationProvider;